import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Tech Stack</h2>
                        <p><br></br> </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" alt="figma"/>
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Figma</h5>
                            </div>
                            <div className="item">
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-plain.svg" alt="bootstrap"/>
                                {/* <img src={meter2} alt="Image" /> */}
                                <h5>Bootstrap</h5>
                            </div>
                            <div className="item">
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" alt="tailwind"/>
                                {/* <img src={meter2} alt="Image" /> */}
                                <h5>Tailwind</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="css3" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>CSS3</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="html5" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>HTML5</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="javascript" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>JavaScript</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" alt="typescript" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>TypeScript</h5>
                            </div>
                            <div className="item">
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="react"/>
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>React</h5>
                            </div>
                            <div className="item">
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" alt="angular"/>
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Angular</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" alt="postgresql" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>PostgreSQL</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" alt="mysql" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>MySQL</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" alt="firebase" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Firebase</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original-wordmark.svg" alt="node" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Node</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" alt="python" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Python</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg" alt="flask" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Flask</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-plain.svg" alt="php" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>PHP</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg" alt="flutter" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Flutter</h5>
                            </div>
                            {/* <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/ruby/ruby-original.svg" alt="ruby" />
                                <h5>Ruby</h5>
                            </div> */}
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg" alt="c" />
                                {/* <img src={meter3} alt="Image" /> */}
                                <h5>C</h5>
                            </div>
                            {/* <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg" alt="cpp" />
                                <h5>C++</h5>
                            </div> */}
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg" alt="cs" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>C#</h5>
                            </div>
                            <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" alt="git" />
                                {/* <img src={meter1} alt="Image" /> */}
                                <h5>Git</h5>
                            </div>
                            {/* <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" alt="java" />
                                <h5>Java</h5>
                            </div> */}
                            {/* <div className="item">        
                                <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg" alt = "swift"/>
                                <h5>Swift</h5>
                            </div> */}
                            {/* <div className="item">
                            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-plain.svg" alt="kotlin" />
                                <h5>Kotlin</h5>
                            </div> */}
                            
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}